import SendIcon from '@mui/icons-material/Send';
import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { StyledButton } from '../../styles/StyledButtons';

const tone: keyof typeof Palette = 'default';

interface StatementEmailComposeFooterProps {
  sending: boolean;
  onCancel: () => void;
  onSend: () => void;
}

/** Cancel/Send action row for StatementEmailComposePanel. */
const StatementEmailComposeFooter: React.FC<StatementEmailComposeFooterProps> = ({
  sending,
  onCancel,
  onSend,
}) => (
  <Box
    sx={{
      p: 2,
      borderTop: `1px solid ${Palette[tone].border}`,
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 2,
    }}
  >
    <StyledButton variant="outlined" onClick={onCancel}>
      Cancel
    </StyledButton>
    <StyledButton
      variant="contained"
      onClick={onSend}
      disabled={sending}
      startIcon={sending ? <CircularProgress size={20} /> : <SendIcon />}
    >
      {sending ? 'Sending...' : 'Send'}
    </StyledButton>
  </Box>
);

export default StatementEmailComposeFooter;
